interface Props {
  width?: string;
  height?: string;
}

const ShareIcon = ({ height, width }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 50 40"
      height={height || "52"}
      width={width || "50"}
    >
      <path d="M6.15 36 4 33.85 18.6 19.3l8.35 8.35L39 15.6h-6.35v-3H44v11.35h-2.95V17.8L26.9 31.95l-8.35-8.35Z" />
    </svg>
  );
};

export default ShareIcon;
